import type { LineRef } from '../../../../arcticapi/types';
import { LineRoundel } from '../../../base/LineRoundel/LineRoundel';
import styles from './StopInfo.module.css';

interface ServedByLinesListProps {
  lines: LineRef[];
}

export function ServedByLinesList({ lines }: ServedByLinesListProps) {
  if (lines.length === 0) {
    return null;
  }

  return (
    <div className={styles.lines} aria-label="Served by lines">
      {lines.map((line) => (
        <LineRoundel key={line.href} line={line} />
      ))}
    </div>
  );
}
